module.exports = __webpack_public_path__ + "img/1b7e639.png";